import React from "react";

import DashleadAPI from "../../api/DashleadAPI";
import ApiUiController from "../../controller/ApiUiController";
import Calculate from "./Calculate";
import FilterDate from "../filter/FilterDate";
import FilterMultiSelect from "../filter/FilterMultiSelect";
import WidgetList from "./WidgetList";
import WidgetTable from "./WidgetTable";
import WidgetPieChart from "./WidgetPieChart";
import WidgetBarGraph from "./WidgetBarGraph";
import WidgetFunnelChart from "./WidgetFunnelChart";
import WidgetMultiBarGraph from "./WidgetMultiBarGraph";
import WidgetMultiLineChart from "./WidgetMultiLineChart";
import ReportConst from "../../util/ReportConst";
import ViewController from "../../controller/ViewController";
import Const from "../../util/Constants";
import Util from "../../util/Util";

class Widget extends React.Component {
  static List = 1;
  static Table = 2;
  static PieChart = 3;
  static BarGraph = 4;
  static LineChart = 5;
  static MultiBarGraph = 6;
  static MultiLineChart = 7;
  static Funnel = 8;
  static Gauge = 9;

  constructor(props) {
    super(props);
    this.state = { inApiCall: true, report: null };
  }

  componentDidMount() {
    DashleadAPI.get(this.props.id, this.onWidget);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.props.id !== props.id) {
      DashleadAPI.get(props.id, this.onWidget);
    }
  }

  onWidget = (res) => {

    this.widget = res;
    let filters = [];
    if (res.json) {
      res.json = JSON.parse(res.json);
      for (let i = 0; i < res.json.filters.length; i++) {
        const filter = { ...res.json.filters[i] };

        filter.value = FilterDate.getValue(
          filter.value ? filter.value : filter.condition
        );

        filter.value = FilterMultiSelect.getDefaultValue(filter.value);
        let j = 0;
        for (; j < filters.length; j++) {
          if (filters[j].field === filter.field) {
            break;
          }
        }
        if (j === filters.length) {
          filters.push(filter);
        } else {
          filters[j] = filter;
        }
      }

      this.model = this.props.models[res.model];

      const Restrict = Util.isAllow(
        this.model.permission,
        Const.PermRestricAcc
      );
      filters = ViewController.filters(filters, [], [], Restrict);
      this.filters = filters;
      if (res.view_type === Widget.List) {
        DashleadAPI.list(
          res.model,
          res.json.per_page,
          filters,
          this.onWidgetData
        );
      } else {
       
        DashleadAPI.data(
          res.model,
          res.sub_model,
          res.type,
          res.x,
          res.y,
          res.z,
          filters,
          this.onWidgetData
        );
      }
    }
  };

  onWidgetData = (data) => {
    const viewType = this.widget.view_type;
    const type = this.widget.type;
    const model = this.widget.model;
    const subModel = this.widget.sub_model;
    let x = this.widget.x;
    let y = this.widget.y;
    const z = this.widget.z;

    let xModel;
    let yModel = model;
    if (x && x.includes(".")) {
      const tmp = x.split(".");
      x = tmp[1];
      if (model && model.includes(" " + tmp[0])) {
        xModel = model;
      } else if (subModel && subModel.includes(" " + tmp[0])) {
        xModel = subModel;
      } else {
        xModel = null;
      }
    } else if (x) {
      xModel = model;
    }

    if (y && y.includes(".")) {
      const tmp = y.split(".");
      y = tmp[1];
      if (model && model.includes(" " + tmp[0])) {
        yModel = model;
      } else if (subModel && subModel.includes(" " + tmp[0])) {
        yModel = subModel;
      } else {
        yModel = null;
      }
    } else if (y) {
      yModel = model;
    }

    if (xModel && xModel.includes(" ")) {
      xModel = xModel.split(" ")[0];
    }
    if (yModel && yModel.includes(" ")) {
      yModel = yModel.split(" ")[0];
    }

    this.table = [];
    if (viewType === Widget.List) {
      this.table = data;
    } else if (type === ReportConst.Select) {
      this.table = Calculate.select(
        xModel,
        yModel,
        x,
        y,
        z,
        this.filters,
        data
      );
    } else if (type === ReportConst.SelectToSelect) {
      this.table = Calculate.select2Select(
        xModel,
        yModel,
        x,
        y,
        z,
        this.filters,
        data
      );
    } else if (type === ReportConst.SelectToMonth) {
      this.table = Calculate.selectToMonth(
        xModel,
        yModel,
        x,
        y,
        z,
        this.filters,
        data
      );
    } else if (type === ReportConst.SelectToDay) {
      this.table = Calculate.selectToDay(
        xModel,
        yModel,
        x,
        y,
        z,
        this.filters,
        data
      );
    } else if (type === ReportConst.Target) {
      this.table = Calculate.target(
        xModel,
        yModel,
        x,
        y,
        z,
        this.filters,
        data
      );
    } else if (type === ReportConst.SelectToHr) {
      this.table = Calculate.selectToHr(
        xModel,
        yModel,
        x,
        y,
        z,
        this.filters,
        data
      );
    }
    this.setState({ ...this.state, inApiCall: false });
  };

  render() {
    let widget = <div></div>;

    if (this.widget && this.widget.view_type === Widget.List) {
      widget = (
        <WidgetList
          widget={this.widget}
          table={this.table}
          model={this.model}
          dashbaord={this.props.dashbaord}
        />
      );
    } else if (this.widget && this.widget.view_type === Widget.Table) {
      widget = (
        <WidgetTable
          widget={this.widget}
          table={this.table}
          model={this.model}
          dashbaord={this.props.dashbaord}
        />
      );
    } else if (this.widget && this.widget.view_type === Widget.PieChart) {
      widget = (
        <WidgetPieChart
          name={this.widget.name}
          table={this.table}
          dashbaord={this.props.dashbaord}
        />
      );
    } else if (this.widget && this.widget.view_type === Widget.BarGraph) {
      widget = (
        <WidgetBarGraph
          name={this.widget.name}
          table={this.table}
          dashbaord={this.props.dashbaord}
        />
      );
    } else if (this.widget && this.widget.view_type === Widget.Funnel) {
      widget = (
        <WidgetFunnelChart
          name={this.widget.name}
          table={this.table}
          dashbaord={this.props.dashbaord}
        />
      );
    } else if (this.widget && this.widget.view_type === Widget.MultiBarGraph) {
      widget = (
        <WidgetMultiBarGraph
          name={this.widget.name}
          table={this.table}
          dashbaord={this.props.dashbaord}
        />
      );
    } else if (this.widget && this.widget.view_type === Widget.MultiLineChart) {
      widget = (
        <WidgetMultiLineChart
          name={this.widget.name}
          table={this.table}
          dashbaord={this.props.dashbaord}
        />
      );
    }
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        {" "}
        {widget}{" "}
      </ApiUiController>
    );
  }
}
export default Widget;
